import { useQuery } from '@tanstack/react-query';

import type { PlaceLocation } from '../context/types';
import { getDiscoveryService } from '../services/discoveryService';

export function useGetXYtoPOI(
  srcBuilding: number | undefined,
  srcFloor: number | undefined,
  srcX: number | undefined,
  srcY: number | undefined,
  key: string | undefined,
  dstPlaceLocation: PlaceLocation | undefined,
) {
  const discoveryService = getDiscoveryService()!;
  return useQuery({
    staleTime: Infinity,
    queryKey: [
      dstPlaceLocation?.id,
      dstPlaceLocation?.building,
      dstPlaceLocation?.floor,
      key,
      srcX,
      srcY,
    ],
    enabled:
      !!dstPlaceLocation &&
      !!srcBuilding &&
      !!srcFloor &&
      !!srcX &&
      !!srcY &&
      !!key,
    queryFn: async () => {
      if (
        dstPlaceLocation?.floor &&
        dstPlaceLocation?.building &&
        dstPlaceLocation?.id &&
        srcBuilding &&
        srcFloor &&
        srcX &&
        srcY &&
        key
      ) {
        const route = await discoveryService.getXYtoPOI(
          srcBuilding,
          srcFloor,
          srcX,
          srcY,
          dstPlaceLocation,
        );
        return route;
      }
    },
  });
}
